/* eslint-disable angular/file-name */
angular.module('zc.zenclerkS')
  .component('zcsServiceName', {
    template: '{{$ctrl.serviceName}}',
    controller: zcsServiceNameController
  });

zcsServiceNameController.$inject = ['$scope', 'ZcsOemService'];
function zcsServiceNameController($scope, ZcsOemService) {
  const vm = this;

  vm.$onInit = () => {
    vm.ZcsOemService = ZcsOemService;
    $scope.$watch(() => ZcsOemService.getName(), serviceName => {
      vm.serviceName = serviceName;
    });
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/service_name/service_name.js